




















import { Component, Vue } from 'vue-property-decorator'

@Component

export default class ViewForbidenn extends Vue {}
